import { useEffect } from 'react';
import { connect } from 'react-redux';
import { busquedaActions } from '../_actions/busqueda.actions';

/**
 * Pide las versiones del modelo elegido y las deja en `filtros.versiones`.
 *
 * No dibuja nada: va al lado de cada combo de version. Existe porque las versiones dejaron
 * de venir en `traerFiltros` —eran ~17.000 filas, el 98% del peso de esa respuesta, para un
 * combo que no sirve hasta que no hay un modelo— y ahora se cargan de a un modelo por vez.
 *
 * Los combos siguen leyendo `filtros.versiones` y filtrando por modelo igual que antes: la
 * lista simplemente tiene solo lo que se fue necesitando.
 *
 * La accion es idempotente (no repite el pedido de un modelo ya cargado), asi que alcanza
 * con montar esto y olvidarse.
 */
function CargadorVersionesBase({ modeloId, traerVersionesDeModelo }) {
	useEffect(() => {
		if (modeloId) traerVersionesDeModelo(modeloId);
	}, [modeloId, traerVersionesDeModelo]);

	return null;
}

export default connect(null, {
	traerVersionesDeModelo: busquedaActions.traerVersionesDeModelo
})(CargadorVersionesBase);
